import React, { useRef } from 'react';
import SessionSection from '../../SessionSection';
import { isSessionEndedMoreThan, SESSION_GRACE_TIME, isSessionEnded, isSessionLive } from '../../sessionBroadcastUtils';
import BroadcastRecords from '../../BroadcastRecords';
import ExternalOnDemand from './ExternalOnDemand';

export default function OnDemandSection({
    siteConf,
    eventUrls,
    session,
    me,
    showEmailLogin,
    event,
    setLoginV2OffsetTop,
    ticketsSelectionData
}) {

    const {
        id: sessionId,
        recordingImageUrl,
        recordingSession = {},
        externalSessionAssets = []
    } = session || {};

    const broadcastRef = useRef();
    const isAuthenticated = me && me.id;
    const eventId = event.id;
    const { color1 } = siteConf;

    const isExternalOnDemand = recordingSession?.recordingPrimaryAssetType === 'EXTERNAL';

    return (
        <div ref={broadcastRef} style={{width: '100%'}}>
            <SessionSection
                color={color1}
                className="session-broadcast-container"
                classChildren={'margin-none'}
                stickSectionsToLeft>
                {isExternalOnDemand ?
                    <ExternalOnDemand
                        event={event}
                        eventUrls={eventUrls}
                        me={me}
                        session={session}
                        showRegisterAndLoginModal={showEmailLogin}
                        showEmailLogin={showEmailLogin}
                        ticketsSelectionData={ticketsSelectionData}
                        siteConf={siteConf}
                    />
                    :
                    <BroadcastRecords
                        eventId={eventId}
                        sessionId={sessionId}
                        recordingIsReady={true}
                        recordingImageUrl={recordingImageUrl}
                        isAuthenticated={isAuthenticated}
                        showEmailLogin={showEmailLogin}
                        eventUrls={eventUrls}
                        recordingSession={recordingSession}
                        setLoginV2OffsetTop={setLoginV2OffsetTop}
                        siteConf={siteConf}
                        ticketsSelectionData={ticketsSelectionData}
                        externalSessionAssets={externalSessionAssets}
                        me={me}
                        session={session}
                    />
                }
            </SessionSection>
        </div>
    );
}
